var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_points_svg__icon_points",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_points_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_points_svg__Rectangle_2919",
    "data-name": "Rectangle 2919",
    className: "icon_points_svg__cls-1",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".icon_points_svg__cls-1,.icon_points_svg__cls-3{fill:none}.icon_points_svg__cls-3{stroke:#575757;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_points_svg__icon_assessments",
    clipPath: "url(#icon_points_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_points_svg__Rectangle_2918",
    "data-name": "Rectangle 2918",
    className: "icon_points_svg__cls-1",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon_points_svg__streamline-icon-award-ribbon-star-1_140x140",
    "data-name": "streamline-icon-award-ribbon-star-1@140x140",
    transform: "translate(2.625 2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_points_svg__Path_2295",
    "data-name": "Path 2295",
    className: "icon_points_svg__cls-3",
    d: "M9.243 76.078l-4.868 5.95 4.5.9 1.8 5.4 4.733-7.51",
    transform: "translate(0 -56.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_points_svg__Path_2296",
    "data-name": "Path 2296",
    className: "icon_points_svg__cls-3",
    d: "M88.158 76.078l4.868 5.95-4.5.9-1.8 5.4-4.733-7.51",
    transform: "translate(-61.651 -56.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_points_svg__Path_2297",
    "data-name": "Path 2297",
    className: "icon_points_svg__cls-3",
    d: "M21.875 14.275a9.9 9.9 0 109.9-9.9 9.9 9.9 0 00-9.9 9.9z",
    transform: "translate(-13.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon_points_svg__Path_2298",
    "data-name": "Path 2298",
    className: "icon_points_svg__cls-3",
    d: "M49.777 23.555l1.5 2.95h2.552a.7.7 0 01.5 1.2l-2.344 2.3 1.3 2.982a.707.707 0 01-1.007.884l-3.138-1.763L46 33.873a.707.707 0 01-1.007-.884l1.3-2.982L43.95 27.7a.7.7 0 01.5-1.2H47l1.5-2.945a.72.72 0 011.273 0z",
    transform: "translate(-31.265 -14.93)"
  })))));
}
export default SvgIconPoints;